import { Account } from './account.model';

export interface Inventory {
    id: number;
    item: Item;
    itemGroup: ItemGroup;
}

export interface Item {
    itemId: number;
    serialNumber: string;
    code: string;
    status: string;
    user: string;
    palletCode?: string;
    // Raw entity relations as returned by GET /api/v1/item/search/{warehouse} — not present
    // on every Item-returning endpoint, hence optional.
    pallet?: { qrCode?: string; location?: string };
    product?: { productId?: number; sku?: string };
    creationDate: Date;
    releaseDate: Date;
    quantity: number;
    initialQuantity: number;
    startQuantity: number;
    description?: string;
    notes?: string;
}

export interface ItemEdit extends Item {
    notes?: string;
}

export interface MassiveItemEdit {
    serialNumber?: string;
    description: string;
    notes: string;
}

export interface NewItem {
    serialNumber: string;
    code: string;
    description: string;
    quantity?: number;
    palletCode?: string;
    account?: Account;
    warehouse?: string;
}

export interface ChangedItem {
    item: Item;
    changes: Item;
}

export interface BulkItemUpdateRequest {
    items: Item[];
}

export interface Pallet {
    palletId?: number;
    depth?: number;
    width?: number;
    height?: number;
    notes?: string
    flooring?: string;
    qrCode?: string;
    location?: string;
    account?: Account;
    warehouse?: string;
    status?: string;
    creationDate?: string;
    updateDate?: string;
    releaseDate?: string;
}

export interface NewPallet {
    depth?: number;
    width?: number;
    height?: number;
    notes?: string
    flooring?: string;
    qrCode?: string;
    location?: string;
    account?: Account;
    warehouse?: string;
}

export interface PalletCreation {
    pallet: NewPallet;
    items: Item[]
}

export interface ItemGroup {
    itemGroupId: number;
    description: string;
    quantity: number;
    type: string;
    warehouse: string;
    account: Account;
    note: string;
}

export interface PageableItems {
    totalElements: number;
    content: Inventory[];
}

export interface PageableItems2 {
    totalElements: number;
    content: Item[];
}

export interface ItemSearchParams {
    warehouse?: string;
    accountId?: number;
    code?: string;
    description?: string;
    palletCode?: string;
    status?: string;
    // Backs both Product Catalog's row-expansion (items for one product) and Articles
    // Inventory's deep-link from there.
    productId?: number;
    creationDateFrom?: string;
    creationDateTo?: string;
    page: number;
    size: number;
    sortBy: string;
    sortDirection: 'ASC' | 'DESC';
}

export interface PalletSearchParams {
    warehouse?: string;
    accountId?: number;
    palletCode?: string;
    status?: string;
    flooring?: string;
    location?: string;
    creationDateFrom?: string;
    creationDateTo?: string;
    page: number;
    size: number;
    sortBy: string;
    sortDirection: 'ASC' | 'DESC';
}

export interface InventoryCreation {
    items: NewItem[],
    pallet: NewPallet | undefined,
    warehouse: string;
    accountId: number;
}


export enum ItemStatus {
    COMPLETED = "COMPLETADO"
}

export interface ItemMovement {
    movementTime: string;
    creationTime: string;
    quantity: number;
    movementType: 'RELEASE' | 'UPDATE';
    movementReason: string;
    user: string;
    changeDetail?: Record<string, ChangeValue> | string;
}

export interface ChangeValue {
    old: any;
    new: any;
}

export interface ItemGroup {
    itemGroupId: number;
    name: string;
    articleCount: number;
    createdByEmail: string;
    creationDate: string;
    exitDate: string;
    warehouse: string;
    items: Item[]
}